import {request, gql} from 'graphql-request'

export interface PairDayData {
  id: string
  date: string
  pairAddress: string
  token0: {
    name: string
    totalSupply: number
  }
  token1: {
    name: string
    totalSupply: number
  }
  dailyVolumeUSD: number
}

interface LBPairDayDatas {
  pairDayDatas: PairDayData[]
}

export const getPoolFeesData = async (graphQLUrl: string, start: number, end: number, first: number = 1000, skip: number = 0): Promise<PairDayData[]> => {
  try {
    const query = gql`
        query pairDayDatas {
            pairDayDatas(
                where: {
                    date_gte: ${start}
                    date_lte: ${end}
                },
                orderBy: date,
                first: ${first},
                skip: ${skip}
            ) {
                id
                date
                pairAddress
                token0 {
                    name
                    totalSupply
                }
                token1 {
                    name
                    totalSupply
                }
                dailyVolumeUSD
            }
        }`
    const lbpairDayData = await request<LBPairDayDatas>(graphQLUrl, query, {})
    return lbpairDayData.pairDayDatas
  } catch (error) {
    console.error('Failed to fetch pool chart data', error)
    return []
  }
}
